import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class SubscribedCourseService extends Service{
    constructor() {
        super();
        this.baseURL = 'subscribedCourse';
    }

    findAllByCourseId(courseId) {
        return fetch(SERVER_URL + this.baseURL + '/findAllByCourseId/' + courseId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            console.log(error);
        });
    }

    findByCourseId(courseId) {
        return fetch(SERVER_URL + this.baseURL + '/findByCourseId/' + courseId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            console.log(error);
        });
    }

    updateLastAccessedTime(courseId) {
        return fetch(SERVER_URL + this.baseURL + '/updateLastAccessedTime/' + courseId, {
            crossDomain: true,
            method: 'put',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            // body: JSON.stringify(GeneralUtils.addUpdateInfo(data))
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}